<div [chart]="currentChart$ | async"></div>
